import { ServiceClient } from 'src/utils'
import type { KeywordOption } from '../the-consumer-market/tcm_scopes'
import type {
    CnpjListagemRequest,
    CnpjPainelResponse,
    ContatosResponse,
    EmpresaRow,
    EstabelecimentoRow,
    ListagemResponse,
    VetFilter,
    WebFilter,
    WebListagemRequest,
    WebPainelResponse
} from './mv_types'

const serviceClient = ServiceClient.singleton

export type CnpjOpcoes = {
    palavras: KeywordOption[]
    cnaes: KeywordOption[]
    secundarias: KeywordOption[]
    colunas?: Record<string, KeywordOption[]>
}

export type WebOpcoes = { municipios: KeywordOption[]; categorias: KeywordOption[]; palavras: KeywordOption[] }

export class MercadoVetService {
    private static readonly INSTANCE = new MercadoVetService()

    public static singleton = () => MercadoVetService.INSTANCE

    // :: Página CNPJ

    async fetchCnpjPainel(filter: VetFilter) {
        return serviceClient().authPost<CnpjPainelResponse>('/api/mercado-vet/cnpj/painel', { filter })
    }

    async fetchCnpjListagem(request: CnpjListagemRequest) {
        return serviceClient().authPost<ListagemResponse<EmpresaRow>>('/api/mercado-vet/cnpj/listagem', request)
    }

    async fetchCnpjOpcoes() {
        return serviceClient().authGet<CnpjOpcoes>('/api/mercado-vet/cnpj/opcoes')
    }

    async fetchCnpjSugestoes(campo: 'razaoSocial' | 'nomeFantasia', texto: string, filter: VetFilter) {
        return serviceClient().authPost<string[]>('/api/mercado-vet/cnpj/sugestoes', { campo, texto, filter })
    }

    // :: Página WEB

    async fetchWebPainel(filter: WebFilter) {
        return serviceClient().authPost<WebPainelResponse>('/api/mercado-vet/web/painel', { filter })
    }

    async fetchWebListagem(request: WebListagemRequest) {
        return serviceClient().authPost<ListagemResponse<EstabelecimentoRow>>('/api/mercado-vet/web/listagem', request)
    }

    async fetchEstabelecimento(id: number) {
        return serviceClient().authGet<EstabelecimentoRow>(`/api/mercado-vet/web/estabelecimento/${id}`)
    }

    async fetchWebOpcoes() {
        return serviceClient().authGet<WebOpcoes>('/api/mercado-vet/web/opcoes')
    }

    // :: Contatos LinkedIn

    async fetchContatos(filter: VetFilter) {
        return serviceClient().authPost<ContatosResponse>('/api/mercado-vet/linkedin', { filter })
    }
}

export default MercadoVetService
